import { render } from "./BaseButton.vue?vue&type=template&id=3f2acca6"
import script from "./BaseButton.vue?vue&type=script&lang=js"
export * from "./BaseButton.vue?vue&type=script&lang=js"

import "./BaseButton.vue?vue&type=style&index=0&id=3f2acca6&lang=css"
script.render = render

export default script